import React from 'react'
import { Info } from 'lucide-react'
import { Flex, Tooltip } from '@workwhile/ui'
import { HighnoteTransferAuditEvent } from 'api/payments/getUserPayments'
import { CopyableCode } from 'components/Shared/CopyableCode'
import { ProviderDetailLine } from './ProviderDetailLine'

const hasUserAuditMetadata = (
  event: Pick<
    HighnoteTransferAuditEvent,
    'ipAddress' | 'deviceId' | 'userAgent' | 'highnoteRequestId'
  >
): boolean =>
  Boolean(
    event.ipAddress ||
      event.deviceId ||
      event.userAgent ||
      event.highnoteRequestId
  )

type AuditEventMetadataTooltipProps = {
  event: HighnoteTransferAuditEvent
}

export const AuditEventMetadataTooltip = ({
  event,
}: AuditEventMetadataTooltipProps) => {
  if (!hasUserAuditMetadata(event)) {
    return null
  }

  return (
    <Tooltip
      variant="neutral"
      content={
        <Flex flexDirection="column" gap={1}>
          <ProviderDetailLine label="IP address">
            {event.ipAddress ? (
              <CopyableCode value={event.ipAddress} />
            ) : (
              'Not recorded'
            )}
          </ProviderDetailLine>
          {event.deviceId ? (
            <ProviderDetailLine label="Device ID">
              <CopyableCode value={event.deviceId} />
            </ProviderDetailLine>
          ) : null}
          {event.userAgent ? (
            <ProviderDetailLine label="User agent">
              <CopyableCode value={event.userAgent} />
            </ProviderDetailLine>
          ) : null}
          {event.highnoteRequestId ? (
            <ProviderDetailLine label="Highnote Request ID">
              <CopyableCode value={event.highnoteRequestId} />
            </ProviderDetailLine>
          ) : null}
        </Flex>
      }
    >
      <Info size={12} />
    </Tooltip>
  )
}
